export const SPENDING_CATEGORIES = {
  'Food & Drinks': {
    'Eating Out': [
      'restaurant', 'hotel', 'dhaba', 'biryani', 'curry', 'tiffin', 'tiffins', 'kitchen', 'dosa', 'tandoor', 'grill',
      'shawarma', 'chinese', 'punjabi', 'south indian', 'north indian', 'buffet', 'barbeque', 'bbq', 'dinner',
      'lunch', 'breakfast', 'brunch', 'cafe', 'canteen', 'mess', 'food court', 'food', 'foods', 'eatery',
      'eateries', 'bhojanalayam', 'meals', 'fine dine', 'fine dining', 'multi cuisine', 'multicuisine',
      'family restaurant', 'veg restaurant', 'non veg restaurant', 'bistro', 'diner', 'steakhouse',
      'seafood restaurant', 'pizzeria', 'sushi bar', 'korean bbq', 'ramen', 'udupi', 'udpi', 'irani cafe',
      'paratha house', 'bakeri', 'udtapunjab', 'garden restaurant',
      // Tier-1 city chains
      'social', 'local', 'theobroma', 'starbucks india', 'blue tokai cafe', 'third wave coffee',
      'haldirams', 'bikanervala', 'saravana bhavan', 'sangeetha veg', 'adarsh restaurant',
      'mainland china', 'barbeque nation', 'absolute barbecues', 'ab s', 'punjab grill',
      'olive bar', 'toscano', 'smoke house deli', 'natural ice cream', 'naturals ice cream',
      'corner house', 'truffles', 'empire restaurant', 'nalapaka', 'ctr malleshwaram',
      'mumbai local', 'bademiya', 'leopold cafe', 'kyani', 'britannia and co'
    ],
    'Take Away': [
      'takeaway', 'take away', 'parcel', 'pack', 'to go', 'take out', 'take-out', 'take home', 'home delivery',
      'self pickup', 'self pick up'
    ],
    'Tea & Coffee': [
      'coffee', 'chai', 'starbucks', 'ccd', 'cafe coffee day', 'barista', 'chai point', 'chaayos',
      'third wave', 'third wave coffee', 'blue tokai', 'dunkin', 'dunkin donuts', 'costa coffee', 'gloria jeans',
      'tims', 'tim hortons', 'tea house', 'tea stall', 'tapri', 'chai tapri', 'tea stall'
    ],
    'Fast Food': [
      'mcdonald', 'mcdonalds', 'kfc', 'domino', 'dominos', 'pizza hut', 'burger king', 'subway', 'wow momo',
      'samosa', 'vada pav', 'burger', 'pizza', 'sandwich', 'fries', 'momos', 'rolls', 'frankie', 'fast food',
      'bowl', 'chinese bowl', 'taco bell', 'popeyes', 'wendys', 'five guys', 'hardees', 'carls jr',
      'fried chicken', 'shawarma roll', 'wraps'
    ],
    'Snacks': [
      'snacks', 'chips', 'biscuit', 'namkeen', 'bhujia', 'pani puri', 'chaat', 'pav bhaji', 'idli', 'dosa',
      'pakoda', 'bhel', 'mixture', 'kurkure', 'lays', 'pringles', 'popcorn', 'nachos', 'murukku', 'chakli'
    ],
    'Swiggy': [
      'swiggy', 'swiggy one', 'swiggy genie', 'swiggy dineout'
    ],
    'Zomato': [
      'zomato', 'zomato pro', 'zomato gold', 'eternal limited', 'zomato dining'
    ],
    'EatClub': [
      'eatclub', 'eat club', 'faasos', 'behrouz', 'ovenstory', 'freshmenu', 'box8', 'lunchbox', 'sweet truth',
      'mandarin oak', 'the good bowl'
    ],
    'Sweets': [
      'sweets', 'mithai', 'haldiram', 'bikaner', 'bikanervala', 'g.pulla reddy', 'pulla reddy', 'almond house',
      'karachi bakery', 'gulab jamun', 'jalebi', 'jilebi', 'ladoo', 'laddu', 'barfi', 'rasgulla', 'rasmalai',
      'sandesh', 'peda', 'soan papdi', 'sweet shop', 'sweet house'
    ],
    'Liquor': [
      'liquor', 'alcohol', 'wine', 'beer', 'whisky', 'vodka', 'rum', 'brandy', 'pub', 'bar', 'club', 'brewery',
      'wine shop', 'theka', 'microbrewery', 'taproom', 'hard liquor', 'liquor store'
    ],
    'Beverages': [
      'juice', 'lassi', 'buttermilk', 'chaas', 'smoothie', 'shake', 'soda', 'soft drink', 'coke', 'pepsi',
      'sprite', 'fanta', 'coconut water', 'nimbu pani', 'energy drink', 'red bull', 'monster', 'paper boat'
    ],
    'Date': [
      'date night', 'dinner date', 'romantic dinner', 'anniversary', 'celebration', 'valentines', 'valentine',
      'birthday dinner', 'birthday lunch'
    ]
  },

  'Transport': {
    'Uber': [
      'uber', 'uber auto', 'uber go', 'uber premier', 'uber xl', 'uber moto'
    ],
    'Rapido': [
      'rapido', 'rapido bike', 'rapido auto', 'rapido ride'
    ],
    'Auto': [
      'auto', 'auto rickshaw', 'autorickshaw', 'tuk tuk', 'rickshaw', 'share auto'
    ],
    'Cab': [
      'cab', 'taxi', 'ola', 'ola cabs', 'namma yatri', 'blusmart', 'meru', 'mega cabs', 'mega cab', 'savaari',
      'savaary', 'in-drive', 'indrive', 'lyft', 'grab', 'bolt', 'didicar'
    ],
    'Train': [
      'train', 'railway', 'irctc', 'mmts', 'rail', 'mmt rail', 'rail ticket', 'tatkal', 'rajdhani', 'shatabdi',
      'duronto', 'local train', 'metro rail', 'e-ticket', 'u-tsav ticket', 'railway reservation'
    ],
    'Metro': [
      'metro', 'metro card', 'metro recharge', 'dmrc', 'bmrc', 'hmrl', 'cmrl', 'mmrda', 'mmrcl', 'jaipur metro',
      'nagpur metro', 'kochimetro'
    ],
    'Bus': [
      'bus', 'bus ticket', 'redbus', 'state bus', 'volvo', 'sleeper', 'bmtc', 'tsrtc', 'ksrtc', 'apsrtc', 'msrtc',
      'upsrtc', 'rsrtc', 'mofussil', 'intercity bus', 'inter state bus', 'flixbus'
    ],
    'Bike': [
      'bike', 'motorcycle', 'scooter', 'two wheeler', 'activa', 'scooty', 'bounce', 'vogo', 'yulu', 'ola electric',
      'ather scooter', 'bike rental', 'zoomcar bike', 'rent a bike'
    ],
    'Fuel': [
      'petrol', 'diesel', 'cng', 'fuel', 'petrol pump', 'fuel station', 'filling station', 'hp', 'indian oil',
      'bharat petroleum', 'bpcl', 'hpcl', 'iocl', 'petro', 'shell', 'essar', 'reliance petrol', 'ufill',
      'gas station', 'fuel surcharge'
    ],
    'EV Charge': [
      'ev charge', 'ev charging', 'charging station', 'electric vehicle', 'ather', 'tata power charge', 'tata ev',
      'charge point', 'chargers', 'charge zone', 'fortum charge'
    ],
    'Flights': [
      'flight', 'air ticket', 'airline', 'indigo', 'spicejet', 'air india', 'vistara', 'akasa', 'goair',
      'airindia express', 'akasa air', 'emirates', 'qatar airways', 'etihad', 'lufthansa', 'british airways',
      'airasia', 'air asia', 'qantas', 'scoot', 'malindo', 'flydubai', 'airarabia'
    ],
    'Parking': [
      'parking', 'park my car', 'valet', 'parking charges', 'parking fee', 'mall parking', 'airport parking',
      'parking lot', 'parking ticket'
    ],
    'FASTag': [
      'fastag', 'fas tag', 'fast tag', 'fastag recharge', 'etc fastag', 'nhai fastag', 'icici fastag',
      'hdfc fastag', 'axis fastag', 'paytm fastag', 'bank fastag'
    ],
    'Tolls': [
      'toll', 'toll plaza', 'toll tax', 'highway toll', 'nhai', 'road toll', 'bridge toll'
    ],
    'Lounge': [
      'lounge', 'airport lounge', 'railway lounge', 'priority pass', 'dreamfolks', 'plaza premium', 'tfs lounge'
    ],
    'Fine': [
      'fine', 'challan', 'traffic fine', 'penalty', 'e-challan', 'traffic police', 'speeding ticket', 'parking fine'
    ],
    'Others': [
      'transport', 'commute', 'travel expense', 'travel', 'travels', 'tour and travels', 'tours', 'shuttle',
      'company cab', 'office cab'
    ]
  },

  'Shopping': {
    'Clothes': [
      'clothes', 'clothing', 'garments', 'garment', 'shirt', 'jeans', 'kurta', 'saree', 'dress', 'trends',
      'zudio', 'zara', 'h&m', 'h and m', 'pantaloons', 'max', 'westside', 'lifestyle', 'shoppers stop',
      'central', 'fbb', 'reliance trends', 'levis', 'levi\'s', 'us polo', 'jack and jones', 'veromoda',
      'vero moda', 'only', 'marks and spencer', 'uniqlo', 'decathlon apparel', 'fabindia', 'manyavar',
      'biba', 'w for woman', 'nykaa fashion', 'ajio fashion', 'emporium', 'collections', 'boutique',
      'textile', 'textiles', 'tailors', 'tailor'
    ],
    'Footwear': [
      'footwear', 'foot wear', 'foot ware', 'footware', 'shoes', 'shoe', 'shoe store', 'shoe shop',
      'sandals', 'slippers', 'sneakers', 'boots', 'heels', 'chappal', 'chappals',
      'bata', 'metro shoes', 'woodland', 'red tape', 'liberty',
      'nike', 'adidas', 'puma', 'reebok', 'skechers', 'crocs', 'clarks', 'hush puppies', 'campus', 'relaxo',
      'sparx', 'shoe palace', 'footwear store', 'footwear shop', 'formal shoes', 'sports shoes'
    ],
    'Electronics': [
      'electronics', 'mobile', 'phone', 'laptop', 'tablet', 'computer', 'croma', 'reliance digital', 'vijay sales',
      'sangeetha', 'poorvika', 'pai international', 'bajaj electronics', 'lot mobiles', 'apple store', 'mi store',
      'oneplus store', 'samsung store', 'vivo store', 'oppo store', 'sony center', 'dell exclusive', 'hp world',
      'asus store', 'lenovo store', 'electronics shop', 'gadget store', 'best buy', 'mediamarkt'
    ],
    'Festival': [
      'festival', 'diwali', 'holi', 'eid', 'christmas', 'puja', 'ganesh chaturthi', 'onam', 'pongal', 'ugadi',
      'navratri', 'durga puja', 'raksha bandhan', 'karwa chauth', 'lohri', 'baisakhi', 'ganpati', 'dussehra',
      'new year party', 'new year eve'
    ],
    'Video Games': [
      'video games', 'gaming', 'ps5', 'playstation', 'xbox', 'nintendo', 'steam', 'epic games', 'console',
      'game store', 'gaming store', 'origin', 'battle.net', 'riot games', 'valorant points', 'roblox', 'in-game'
    ],
    'Books': [
      'books', 'book store', 'bookshop', 'amazon kindle', 'crossword', 'landmark', 'om book shop',
      'textbook', 'stationery', 'book fair', 'book depot', 'ebooks', 'kindle book', 'audible'
    ],
    'Plants': [
      'plants', 'nursery', 'garden', 'planter', 'seeds', 'fertilizer', 'gardening', 'pots', 'indoor plants',
      'ikea plants', 'mybageecha', 'ugaoo'
    ],
    'Jewellery': [
      'jewellery', 'jewelry', 'jewlery', 'jewellry', 'silver', 'diamond', 'tanishq', 'kalyan',
      'joyalukkas', 'malabar', 'grt', 'pc jeweller', 'bluestone', 'caratlane', 'tribhovandas', 'jewelers',
      'jeweller', 'jewellery shop', 'gold jewellery', 'gold chain', 'gold ring'
    ],
    'Furniture': [
      'furniture', 'sofa', 'bed', 'table', 'chair', 'wardrobe', 'ikea', 'pepperfry', 'urban ladder',
      'godrej interio', 'durian', 'hometown', 'evok', 'nilkamal', 'royaloak', 'sleepwell', 'wakefit', 'flo mattress'
    ],
    'Appliances': [
      'appliances', 'washing machine', 'refrigerator', 'fridge', 'ac', 'air conditioner', 'tv', 'television',
      'microwave', 'oven', 'mixer', 'grinder', 'fan', 'cooler', 'geyser', 'water heater', 'chimney', 'dishwasher',
      'air fryer', 'purifier', 'water purifier', 'ro filter'
    ],
    'Utensils': [
      'utensils', 'kitchenware', 'cookware', 'vessels', 'plates', 'glasses', 'pressure cooker', 'kadhai', 'tawa',
      'prestige', 'hawkins', 'pigeon', 'borosil', 'milton', 'casserole', 'cookware set'
    ],
    'Vehicle': [
      'vehicle', 'car', 'bike purchase', 'scooter purchase', 'accessories', 'spare parts', 'tyres', 'battery',
      'car accessories', 'bike accessories', 'auto parts', 'car decor', 'helmet', 'riding gear', 'seat cover',
      'maruti showroom', 'tata motors', 'mahindra showroom', 'hyundai showroom', 'kia showroom', 'royal enfield'
    ],
    'Cosmetics': [
      'cosmetics', 'makeup', 'lipstick', 'foundation', 'mascara', 'nykaa', 'lakme', 'maybelline', 'colorbar',
      'mac', 'sugar cosmetics', 'kay beauty', 'sephora', 'huda beauty', 'beauty store', 'beauty shop', 'makeup kit'
    ],
    'Toys': [
      'toys', 'toy store', 'games', 'puzzles', 'lego', 'hamleys', 'kidzo', 'r for rabbit', 'firstcry', 'barbie',
      'hot wheels', 'nerf', 'board game', 'action figure'
    ],
    'Stationery': [
      'stationery', 'pens', 'notebooks', 'pencils', 'markers', 'office supplies', 'xerox', 'printing',
      'lamination', 'copier', 'paper', 'file', 'folder'
    ],
    'Glasses': [
      'glasses', 'spectacles', 'eyewear', 'sunglasses', 'lenskart', 'titan eye', 'vision express',
      'contact lens', 'opticals', 'optician'
    ],
    'Devotional': [
      'devotional', 'pooja', 'puja items', 'agarbatti', 'diya', 'camphor', 'god idol', 'temple items', 'religious',
      'mandir items', 'havan samagri'
    ],
    'Online Shopping': [
      'amazon', 'flipkart', 'myntra', 'ajio', 'meesho', 'snapdeal', 'tata cliq', 'nykaa', 'firstcry', 'bewakoof',
      'decathlon', 'shopify', 'ebay', 'aliexpress', 'etsy', 'shein', 'temu',
      // Tier-1 / national retail
      'croma', 'reliance digital', 'vijay sales', 'lifestyle stores', 'shoppers stop', 'westside',
      'pantaloons', 'max fashion', 'zudio', 'hm store', 'zara india', 'uniqlo india',
      'ikea', 'pepperfry', 'urban ladder', 'hometown', 'nilkamal',
      'purplle', 'foxtale', 'mamaearth', 'boat lifestyle', 'noise', 'oneplus',
      'lenskart', 'titan', 'fastrack', 'wildcraft', 'puma store', 'adidas store', 'nike store'
    ],
    'General': [
      'store', 'stores', 'shop', 'shops', 'fancy', 'fancy store', 'fancy stores', 'general store',
      'general stores', 'kirana', 'provision', 'provision store', 'departmental', 'mini mart', 'mart', 'bazaar',
      'super bazaar', 'corner shop', 'traders', 'trader', 'trading co', 'enterprises shop'
    ]
  },

  'Groceries': {
    'Staples': [
      'staples', 'rice', 'wheat', 'flour', 'atta', 'dal', 'pulses', 'sugar', 'salt', 'oil', 'ghee', 'spices',
      'masala', 'aashirvaad atta', 'fortune oil', 'patanjali atta', 'organic staples', 'basmati', 'toor dal',
      'chana dal', 'masoor dal'
    ],
    'Vegetables': [
      'vegetables', 'sabzi', 'veggies', 'fresh vegetables', 'greens', 'leafy', 'potato', 'onion', 'tomato',
      'bhindi', 'brinjal', 'cabbage', 'cauliflower', 'vegetable shop'
    ],
    'Fruits': [
      'fruits', 'fresh fruits', 'banana', 'mango', 'orange', 'grapes', 'pomegranate', 'watermelon',
      'fruit shop', 'fruit vendor', 'apple fruit', 'fresh apple'
    ],
    'Meat': [
      'meat', 'chicken', 'mutton', 'fish', 'prawns', 'seafood', 'eggs', 'non veg', 'licious', 'freshmeat',
      'zappfresh', 'fresh to home', 'freshtohome', 'meat shop', 'butcher'
    ],
    'Eggs': [
      'eggs', 'egg', 'egg tray', 'egg box', 'poultry', 'anda eggs', 'egg center'
    ],
    'Bakery': [
      'bakery', 'bread', 'bun', 'cake', 'pastry', 'cookies', 'biscuits', 'britannia', 'parle', 'modern bread',
      'cake shop', 'pastry shop', 'bakers', 'baking'
    ],
    'Dairy': [
      'dairy', 'milk', 'curd', 'paneer', 'butter', 'cheese', 'cream', 'amul', 'mother dairy', 'nandini',
      'heritage', 'gokul', 'aavin', 'sabarmati milk', 'milk booth'
    ],
    'Zepto': [
      'zepto', 'zepto marketplace'
    ],
    'Blinkit': [
      'blinkit', 'grofers'
    ],
    'Instamart': [
      'instamart', 'swiggy instamart'
    ],
    'BigBasket': [
      'bigbasket', 'big basket', 'bbnow', 'bb now', 'bb daily'
    ],
    'Dunzo': [
      'dunzo', 'dunzo daily'
    ],
    'MilkBasket': [
      'milkbasket', 'milk basket'
    ],
    'JioMart': [
      'jiomart', 'jio mart', 'reliance fresh', 'reliance smart', 'smart point'
    ],
    'Supermarket': [
      'dmart', 'big bazaar', 'more supermarket', 'super market', 'supermarket', 'spar', 'star bazaar',
      'ratnadeep', 'spencer', 'lulu', 'hypercity', 'amazon pay groceries', 'amazon fresh',
      'walmart', 'tesco', 'carrefour', 'nature basket', 'foodhall', 'gourmet'
    ]
  },

  'Home': {
    'Rent': [
      'rent', 'house rent', 'flat rent', 'room rent', 'pg rent', 'hostel rent', 'lease payment', 'tenancy'
    ],
    'Essentials': [
      'essentials', 'household', 'home essentials', 'daily needs', 'home needs'
    ],
    'Toiletries': [
      'toiletries', 'soap', 'shampoo', 'toothpaste', 'toothbrush', 'toilet paper', 'tissues', 'sanitizer',
      'handwash', 'deo', 'deodorant', 'body wash', 'face wash'
    ],
    'Decor': [
      'decor', 'home decor', 'wall art', 'curtains', 'bedsheets', 'cushions', 'rugs', 'carpets', 'mirrors',
      'lighting', 'lamps', 'vases', 'showpiece'
    ],
    'Cleaning': [
      'cleaning', 'broom', 'mop', 'vacuum', 'detergent', 'phenyl', 'lizol', 'harpic', 'colin',
      'cleaning supplies', 'cleaner', 'toilet cleaner', 'dishwash', 'scotch brite'
    ],
    'Upkeep': [
      'upkeep', 'maintenance', 'repair', 'fixing', 'servicing', 'home service', 'handyman'
    ],
    'Painting': [
      'painting', 'house painting', 'wall painting', 'asian paints', 'berger', 'nerolac', 'painter', 'paint store'
    ],
    'Renovation': [
      'renovation', 'remodeling', 'interior design', 'false ceiling', 'flooring', 'tiles',
      'kitchen renovation', 'bathroom renovation', 'modular kitchen', 'interior decorator'
    ],
    'Pest Control': [
      'pest control', 'termite', 'cockroach', 'mosquito', 'fumigation', 'pci', 'pest service'
    ],
    'Construction': [
      'construction', 'building', 'contractor', 'mason', 'cement', 'bricks', 'steel', 'sand', 'gravel',
      'hardware store', 'building material'
    ]
  },

  'Entertainment': {
    'Movies': [
      'movie', 'cinema', 'theatre', 'pvr', 'inox', 'cinepolis', 'carnival cinemas', 'bookmyshow', 'film',
      'multiplex', 'big cinema', 'inox movies', 'pvr inox', 'imax', 'miraj cinemas'
    ],
    'Shows': [
      'show', 'theatre show', 'drama', 'play', 'musical', 'opera', 'live show', 'stage show'
    ],
    'Bowling': [
      'bowling', 'bowling alley', 'smaaash', 'timezone', 'strike bowling'
    ],
    'Arcade': [
      'arcade', 'gaming zone', 'game parlour', 'amusement', 'funcity', 'play area', 'game arcade'
    ],
    'Concerts': [
      'concert', 'live music', 'gig', 'music festival', 'nh7', 'sunburn', 'vh1', 'live performance'
    ],
    'Standup Comedy': [
      'standup', 'comedy', 'comedy show', 'open mic', 'comic con', 'laughing club', 'stand-up'
    ],
    'Workshops': [
      'workshop', 'masterclass', 'learning session', 'art workshop', 'cooking class', 'photography workshop',
      'dance workshop'
    ]
  },

  'Travel': {
    'Activities': [
      'activities', 'sightseeing', 'tour', 'excursion', 'adventure', 'trekking', 'hiking', 'rafting', 'paragliding',
      'scuba', 'snorkeling', 'city tour', 'day trip', 'boat ride', 'safari'
    ],
    'Camping': [
      'camping', 'camp', 'tent', 'glamping', 'outdoor camping', 'campfire', 'camp stay'
    ],
    'Hotel': [
      'hotel', 'booking.com', 'bookingcom', 'resort', 'lodge', 'inn', 'guesthouse', 'marriott', 'taj', 'oberoi',
      'hyatt', 'radisson', 'lemon tree', 'treebo', 'fabhotels', 'ginger', 'ibis', 'novotel', 'leela', 'park hyatt',
      'stay', 'staycation'
    ],
    'Commute': [
      'commute', 'local travel', 'city travel', 'sightseeing transport', 'tourist cab'
    ],
    'Meals': [
      'travel meals', 'highway dhaba', 'restaurant during travel', 'inflight meal', 'train food'
    ],
    'Visa Fees': [
      'visa', 'visa fee', 'visa application', 'embassy fee', 'travel visa', 'vfs', 'vfs global'
    ],
    'Hostel': [
      'hostel', 'backpacker', 'zostel', 'gostops', 'goStops', 'hostelworld', 'backpacker hostel'
    ],
    'Airbnb': [
      'airbnb', 'vacation rental', 'homestay', 'home stay', 'vrbo', 'stayz'
    ],
    'OYO': [
      'oyo', 'oyo rooms', 'oyo hotels', 'budget hotel'
    ],
    'Booking': [
      'makemytrip', 'goibibo', 'cleartrip', 'yatra', 'ixigo', 'agoda', 'booking.com', 'trivago', 'expedia',
      'airbnb booking', 'trip.com'
    ]
  },

  'Medical': {
    'Medicines': [
      'medicine', 'pharmacy', 'medical store', 'medical', 'medicals', 'chemist', 'pharmeasy', '1mg', 'netmeds',
      'apollo pharmacy', 'medplus', 'wellness forever', 'frank ross', 'tablets', 'syrup', 'capsules',
      'online pharmacy'
    ],
    'Hospital': [
      'hospital', 'medical center', 'nursing home', 'apollo hospital', 'fortis', 'max hospital', 'manipal hospital',
      'narayana hospital', 'narayana health', 'aiims', 'medanta', 'kokilaben', 'super speciality',
      'superspeciality', 'multi speciality', 'multispeciality', 'health care', 'healthcare', 'care center',
      'emergency', 'casualty'
    ],
    'Clinic': [
      'clinic', 'polyclinic', 'health clinic', 'doctor clinic', 'practo', 'visit', 'doctor consultation',
      'teleconsultation'
    ],
    'Dentist': [
      'dentist', 'dental', 'dental clinic', 'tooth', 'teeth', 'oral care', 'clove dental', 'sabka dentist',
      'mydentist', 'orthodontist'
    ],
    'Lab Test': [
      'lab', 'laboratory', 'blood test', 'lab test', 'diagnostic', 'diagnostics', 'laboratory', 'thyrocare', 'lal path', 'dr lal', 'metropolis',
      'srl', 'scan', 'xray', 'mri', 'ct scan', 'pathology', 'health checkup'
    ],
    'Hygiene': [
      'hygiene', 'sanitary', 'sanitizer', 'masks', 'gloves', 'first aid', 'hand rub', 'disinfectant'
    ]
  },

  'Personal': {
    'Self Care': [
      'self care', 'personal care', 'skincare', 'bodycare', 'wellness', 'sheet mask', 'serum', 'moisturizer'
    ],
    'Grooming': [
      'grooming', 'salon', 'parlour', 'spa', 'haircut', 'hair salon', 'naturals', 'green trends', 'jawed habib',
      'bounce', 'looks', 'vlcc', 'lakme salon', 'bodycraft', 'beard trim', 'facial', 'manicure', 'pedicure',
      'waxing', 'beauty parlour', 'barber', 'grooming lounge'
    ],
    'Hobbies': [
      'hobby', 'hobbies', 'art', 'craft', 'music', 'dance', 'photography', 'painting', 'sketching', 'pottery',
      'gardening', 'reading', 'writing', 'collecting', 'diy', 'model kits'
    ],
    'Vices': [
      'cigarette', 'tobacco', 'gutka', 'paan', 'beedi', 'smoking', 'hookah', 'sheesha', 'vape', 'e-cigarette'
    ],
    'Therapy': [
      'therapy', 'counseling', 'psychologist', 'psychiatrist', 'mental health', 'therapist', 'wellness therapy',
      'meditation', 'online therapy', 'mindfulness app'
    ]
  },

  'Fitness': {
    'Gym': [
      'gym', 'fitness center', 'cult.fit', 'curefit', 'gold gym', 'gold\'s gym', 'talwalkars', 'fitness first',
      'anytime fitness', 'snap fitness', 'crossfit', 'gym membership', 'fitness club'
    ],
    'Badminton': [
      'badminton', 'badminton court', 'shuttlecock', 'racket', 'sports arena'
    ],
    'Football': [
      'football', 'soccer', 'futsal', 'football ground', 'turf booking'
    ],
    'Cricket': [
      'cricket', 'cricket ground', 'cricket net', 'box cricket', 'gully cricket', 'cricket academy'
    ],
    'Classes': [
      'fitness class', 'yoga', 'zumba', 'aerobics', 'pilates', 'spinning', 'dance class', 'martial arts',
      'swimming', 'swimming pool', 'yoga class'
    ],
    'Equipment': [
      'gym equipment', 'dumbbell', 'barbell', 'treadmill', 'cycle', 'yoga mat', 'resistance band', 'kettlebell',
      'decathlon', 'sports shop', 'sports store'
    ],
    'Nutrition': [
      'nutrition', 'protein powder', 'whey', 'supplements', 'vitamins', 'bcaa', 'pre workout', 'myprotein',
      'muscleblaze', 'optimum nutrition', 'healthkart', 'gainer', 'creatine'
    ]
  },

  'Services': {
    'Laundry': [
      'laundry', 'dry cleaning', 'ironing', 'laundromat', 'washio', 'uclean', 'laundry basket', 'dhobi',
      'cloth wash'
    ],
    'Tailor': [
      'tailor', 'alteration', 'stitching', 'boutique', 'fitting', 'blouse stitching', 'suit stitching'
    ],
    'Courier': [
      'courier', 'delivery', 'shipping', 'blue dart', 'delhivery', 'dtdc', 'fedex', 'dhl', 'india post',
      'speed post', 'ecom express', 'xpressbees', 'shadowfax'
    ],
    'Carpenter': [
      'carpenter', 'woodwork', 'furniture repair', 'cabinet', 'wood worker'
    ],
    'Plumber': [
      'plumber', 'plumbing', 'pipe', 'tap', 'leak', 'drainage', 'bathroom fitting'
    ],
    'Mechanic': [
      'mechanic', 'car mechanic', 'bike mechanic', 'garage', 'auto repair', 'service center', 'workshop',
      'car service', 'bike service'
    ],
    'Home services': [
      'urban company', 'urbanclap', 'housejoy', 'beauty services at home', 'appliance repair home'
    ],
    'Photographer': [
      'photographer', 'photography', 'photo studio', 'photoshoot', 'videography', 'wedding photography',
      'pre-wedding shoot'
    ],
    'Driver': [
      'driver', 'driver salary', 'chauffeur', 'personal driver'
    ],
    'Vehicle Wash': [
      'car wash', 'bike wash', 'vehicle wash', 'cleaning', 'detailing', 'polish', 'car spa'
    ],
    'Electrician': [
      'electrician', 'electrical', 'wiring', 'switch', 'socket', 'fan installation', 'ac installation',
      'lighting work'
    ],
    'Painting': [
      'painter', 'house painter', 'paint job', 'wall painting service'
    ],
    'Legal': [
      'legal', 'lawyer', 'advocate', 'attorney', 'legal fees', 'court fees', 'documentation', 'notary',
      'stamp paper', 'legal consultation'
    ],
    'Advisor': [
      'advisor', 'consultant', 'ca', 'chartered accountant', 'tax consultant', 'financial advisor',
      'investment advisor', 'consultancy'
    ],
    'Repair': [
      'repair', 'fix', 'service', 'maintenance', 'urban clap', 'urban company', 'housejoy', 'zimmber', 'mobiles',
      'screen replacement', 'device repair', 'laptop repair'
    ],
    'Logistics': [
      'logistics', 'movers', 'packers', 'shifting', 'relocation', 'agarwal packers', 'porter',
      'packers and movers'
    ]
  },

  'Bill': {
    'Phone': [
      'phone bill', 'mobile bill', 'postpaid', 'prepaid recharge', 'airtel', 'jio prepaid', 'vi', 'bsnl', 'vodafone',
      'idea', 'airtel prepaid', 'vi prepaid', 'mobile recharge', 'airtel thanks', 'jio recharge', 'tata play'
    ],
    'Rent': [
      'rent payment', 'monthly rent', 'rent transfer', 'no broker rent', 'nobroker rent'
    ],
    'Water': [
      'water bill', 'water tax', 'water charges', 'bwssb', 'jal board', 'water supply bill'
    ],
    'Electricity': [
      'electricity', 'power bill', 'current bill', 'bescom', 'tsspdcl', 'msedcl', 'bses', 'tata power',
      'adani power', 'mseb', 'electricity board', 'bbps', 'bharat billpay', 'billpay', 'bharat bill pay'
    ],
    'Gas': [
      'lpg', 'cylinder', 'indane', 'bharatgas', 'hp gas', 'piped gas', 'png', 'book my cylinder',
      'gas bill'
    ],
    'Internet': [
      'internet', 'broadband', 'wifi', 'act fibernet', 'airtel xstream', 'jio fiber', 'hathway', 'you broadband',
      'tikona', 'spectra', 'excitel', 'netplus'
    ],
    'Payments rail': [
      'razorpay', 'payu', 'cashfree', 'ccavenue', 'billdesk', 'atom pay', 'easebuzz'
    ],
    'House Help': [
      'house help', 'maid', 'domestic help', 'ayah', 'bai', 'servant', 'helper', 'cook maid', 'housekeeping'
    ],
    'Education': [
      'school fee', 'college fee', 'tuition fee', 'coaching', 'course fee', 'exam fee', 'admission fee', 'byju',
      'unacademy', 'vedantu', 'whitehat', 'upgrad', 'simplilearn', 'allen', 'akash', 'fiitjee'
    ],
    'DTH': [
      'dth', 'dish tv', 'sun direct', 'tata sky', 'airtel digital tv', 'd2h', 'videocon', 'set top box'
    ],
    'Cook': [
      'cook', 'chef', 'cooking service', 'tiffin service', 'home cook'
    ],
    'Maintenance': [
      'maintenance', 'society maintenance', 'apartment maintenance', 'building maintenance', 'amc',
      'annual maintenance', 'maintenance bill', 'association charges'
    ]
  },

  'Subscription': {
    'Software': [
      'software', 'saas', 'microsoft', 'office 365', 'adobe', 'antivirus', 'cloud storage', 'dropbox',
      'google one', 'icloud', 'notion', 'slack', 'zoom', 'canva', 'figma', 'github copilot', 'jetbrains',
      '1password', 'lastpass'
    ],
    'News': [
      'news', 'newspaper', 'magazine', 'times of india', 'hindu', 'economic times', 'mint', 'livemint',
      'moneycontrol', 'wall street journal', 'wsj', 'nytimes', 'new york times', 'the ken', 'morning context',
      'bloomberg'
    ],
    'Netflix': [
      'netflix', 'netflix india'
    ],
    'Prime': [
      'amazon prime', 'prime video', 'prime membership', 'prime subscription'
    ],
    'YouTube': [
      'youtube', 'youtube premium', 'youtube music'
    ],
    'Spotify': [
      'spotify', 'spotify premium', 'spotify india', 'jiosaavn pro', 'gaana plus', 'wynk premium'
    ],
    'Google': [
      'google one', 'google drive', 'google workspace', 'gsuite', 'g-suite'
    ],
    'Learning': [
      'learning', 'coursera', 'udemy', 'linkedin learning', 'skillshare', 'masterclass', 'edx', 'pluralsight',
      'brilliant.org', 'brilliant', 'byju premium'
    ],
    'Apple': [
      'apple music', 'apple tv', 'apple one', 'app store', 'icloud storage', 'apple arcade'
    ],
    'Bumble': [
      'bumble', 'bumble premium', 'tinder', 'tinder gold', 'hinge', 'tinder plus', 'tinder platinum'
    ],
    'JioHotstar': [
      'jiohotstar', 'hotstar', 'disney hotstar', 'disney plus hotstar'
    ],
    'Google Play': [
      'google play', 'play store', 'playstore', 'google play pass', 'play subscription'
    ],
    'Xbox': [
      'xbox', 'xbox game pass', 'xbox live', 'xbox gold'
    ],
    'PlayStation': [
      'playstation', 'psn', 'ps plus', 'playstation plus', 'ps now', 'ps extra', 'ps deluxe'
    ],
    'Disney Plus': [
      'disney plus', 'disney+', 'disney hotstar'
    ],
    'Zee5': [
      'zee5', 'zee 5'
    ],
    'ChatGPT': [
      'chatgpt', 'openai', 'gpt plus', 'claude', 'anthropic', 'midjourney', 'perplexity', 'ai subscription',
      'copilot', 'replika', 'otter.ai'
    ],
    'Others': [
      'subscription', 'monthly subscription', 'annual subscription', 'membership', 'autopay', 'recurring',
      'auto debit', 'plan renewal', 'subscribed'
    ]
  },

  'EMI': {
    'House': [
      'home loan', 'housing loan', 'home emi', 'mortgage', 'hdfc home', 'sbi home loan', 'icici home',
      'lic housing', 'home finance', 'hl emi'
    ],
    'Vehicle': [
      'car loan', 'bike loan', 'vehicle loan', 'auto loan', 'car emi', 'bike emi', 'two wheeler loan'
    ],
    'Gadget': [
      'gadget emi', 'phone emi', 'laptop emi', 'appliance emi', 'bajaj finserv', 'bajaj finance',
      'hdfc debit emi', 'hdfc emi', 'icici emi', 'sbi emi', 'axis emi', 'kotak emi',
      'amazon pay emi', 'flipkart pay later', 'no cost emi', 'loan emi', 'bank emi'
    ],
    'Education': [
      'education loan', 'student loan', 'study loan', 'hdfc credila', 'avanse', 'incred', 'axis education loan'
    ],
    'Personal': [
      'personal loan', 'loan emi', 'installment', 'money view', 'kreditbee', 'navi', 'zest money',
      'cashe', 'early salary', 'slice emi', 'paylater emi', 'home credit', 'tvscredit'
    ]
  },

  'Credit Bill': {
    'Credit Card': [
      'credit card', 'credit card bill', 'credit card payment', 'cc bill', 'cc payment', 'hdfc credit',
      'sbi credit', 'icici credit', 'axis credit', 'kotak credit', 'amex', 'american express',
      'standard chartered credit', 'rbl credit', 'yes bank credit'
    ],
    'Simpl': [
      'simpl', 'simpl pay'
    ],
    'Slice': [
      'slice', 'slice card', 'slice pay'
    ],
    'LazyPay': [
      'lazypay', 'lazy pay'
    ],
    'Amazon Pay': [
      'amazon pay later', 'amazon pay emi', 'amazon pay credit'
    ],
    'Cred': [
      'cred', 'cred bill pay', 'cred upi'
    ],
    'Others': [
      'bnpl', 'buy now pay later', 'postpe', 'uni card', 'paytm postpaid', 'freecharge pay later',
      'flipkart pay later', 'mobikwik zip'
    ]
  },

  'Investment': {
    'Mutual Fund': [
      'mutual fund', 'mf', 'sip', 'systematic investment', 'elss', 'debt fund', 'equity fund', 'hybrid fund',
      'index fund', 'liquid fund', 'balanced fund', 'smallcap fund', 'midcap fund'
    ],
    'Stocks': [
      'stocks', 'shares', 'equity', 'nse', 'bse', 'trading', 'intraday', 'delivery', 'demat', 'equity delivery'
    ],
    'IPO': [
      'ipo', 'initial public offering', 'ipo application', 'ipo allotment', 'primary market'
    ],
    'PPF': [
      'ppf', 'public provident fund'
    ],
    'NPS': [
      'nps', 'national pension scheme', 'pension fund', 'atal pension'
    ],
    'Fixed Deposit': [
      'fixed deposit', 'fd', 'bank fd', 'corporate fd', 'term deposit'
    ],
    'Recurring Deposit': [
      'recurring deposit', 'rd', 'monthly deposit', 'recurring investment'
    ],
    'Assets': [
      'assets', 'property', 'land', 'plot', 'real estate', 'flat booking', 'villa booking'
    ],
    'Crypto': [
      'crypto', 'bitcoin', 'ethereum', 'cryptocurrency', 'wazirx', 'coinswitch', 'zebpay', 'coindcx',
      'binance', 'coinbase'
    ],
    'Gold': [
      'digital gold', 'sovereign gold', 'sgb', 'gold etf', 'gold bond', 'gold coin', 'gold bar',
      'jewellery gold scheme'
    ],
    'Chit Fund': [
      'chit', 'chitfund', 'chit fund', 'margadarsi', 'shriram chits', 'mysore chits'
    ],
    'Broker': [
      'zerodha', 'groww', 'upstox', 'angel one', 'paytm money', 'kuvera', '5paisa', 'iifl',
      'motilal oswal', 'hdfc securities', 'icici direct', 'kotak securities', 'sharekhan', 'coin',
      'smallcase'
    ]
  },

  'Education': {
    'School & College': [
      'school fee', 'school fees', 'college fee', 'university fee', 'semester fee', 'admission fee',
      'exam fee', 'tuition', 'tuition fee', 'hostel fee', 'education fee', 'academic fee'
    ],
    'Coaching': [
      'coaching', 'coaching centre', 'coaching center', 'tuition centre', 'tuition center', 'private tutor',
      'home tutor', 'jee', 'neet', 'ias academy', 'bank exam', 'competitive exam'
    ],
    'Online Learning': [
      'byju', 'byjus', 'unacademy', 'vedantu', 'upgrad', 'simplilearn', 'coursera', 'udemy', 'edx',
      'skillshare', 'masterclass', 'linkedin learning', 'pluralsight', 'physics wallah', 'pw app'
    ],
    'Books & Supplies': [
      'textbook', 'notebooks', 'study material', 'stationery shop', 'xerox notes', 'exam prep'
    ]
  },

  'Rent': {
    'House Rent': [
      'house rent', 'home rent', 'rent payment', 'monthly rent', 'landlord', 'land lord', 'flat rent',
      'apartment rent', 'house owner', 'rent to owner'
    ],
    'PG & Hostel': [
      'pg rent', 'paying guest', 'pg fee', 'hostel rent', 'hostel fee', 'mess fee', 'room rent'
    ],
    'Office Rent': [
      'office rent', 'shop rent', 'warehouse rent', 'commercial rent', 'godown rent'
    ]
  },

  'Beauty & Grooming': {
    'Salon': [
      'salon', 'hair salon', 'haircut', 'naturals salon', 'green trends', 'jawed habib', 'lakme salon',
      'bodycraft', 'looks salon', 'vlcc', 'bounce salon', 'grooming lounge'
    ],
    'Parlour & Spa': [
      'parlour', 'parlor', 'beauty parlour', 'beauty parlor', 'spa', 'facial', 'manicure', 'pedicure',
      'waxing', 'bridal makeup', 'makeup studio'
    ],
    'Barber': [
      'barber', 'beard trim', 'mens salon', 'gents salon', 'hair dresser'
    ],
    'Products': [
      'skincare', 'serum', 'moisturizer', 'nykaa', 'beauty store', 'beauty shop', 'cosmetics store'
    ]
  },

  'Donations & Religion': {
    'Temple & Worship': [
      'temple', 'mandir', 'church', 'mosque', 'gurudwara', 'ttd', 'tirupati', 'hundi', 'ehundi',
      'dakshina', 'offering', 'seva', 'prasad', 'pooja donation'
    ],
    'Charity': [
      'donation', 'charity', 'ngo', 'give india', 'milaap', 'ketto', 'crowdfunding', 'zakat', 'fitra',
      'relief fund', 'pm cares', 'cm relief'
    ],
    'Religious Items': [
      'pooja items', 'puja items', 'agarbatti', 'camphor', 'havan samagri', 'god idol'
    ]
  },

  'Family & Friends': {
    'Friends': [
      'friend', 'frnd'
    ],

    'Pocket Money': [
      'pocket money', 'allowance', 'monthly allowance'
    ],
    'Family Transfer': [
      'family transfer', 'money to family', 'home remittance', 'send money home', 'transfer to parents',
      'upi to mom', 'upi to dad'
    ],
    'Parents': [
      'parents', 'mom', 'dad', 'mother', 'father', 'mummy', 'papa', 'family support', 'amma', 'appa',
      'ammamma', 'tatayya'
    ],
    'Spouse': [
      'spouse', 'wife', 'husband', 'partner', 'better half'
    ],
    'Personal Transfer': [],
    'Siblings': [
      'brother', 'sister', 'sibling', 'bhai', 'behen', 'anna', 'akka', 'didi'
    ]
  },

  'Insurance': {
    'Health': [
      'health insurance', 'mediclaim', 'medical insurance', 'star health', 'max bupa', 'hdfc ergo health',
      'icici lombard health', 'niva bupa', 'care health', 'policybazaar health'
    ],
    'Vehicle': [
      'vehicle insurance', 'car insurance', 'bike insurance', 'motor insurance', 'third party', 'comprehensive',
      'acko', 'digit insurance', 'tata aig motor', 'bajaj allianz motor', 'icici lombard motor'
    ],
    'Life': [
      'life insurance', 'term insurance', 'term plan', 'lic', 'hdfc life', 'icici prudential', 'sbi life',
      'max life', 'tata aia', 'kotak life', 'pnb metlife'
    ],
    'Electronics': [
      'electronics insurance', 'mobile insurance', 'gadget insurance', 'extended warranty', 'accidental damage',
      'screen protection', 'onemg protect', 'applecare'
    ]
  },

  'Tax': {
    'Income Tax': [
      'income tax', 'it payment', 'advance tax', 'tds', 'itr', 'income tax return', 'form 26as',
      'self assessment tax'
    ],
    'GST': [
      'gst', 'goods and services tax', 'gst payment', 'gst return', 'gstr', 'gstr-3b', 'gstr1'
    ],
    'Property Tax': [
      'property tax', 'house tax', 'municipal tax', 'corporation tax', 'bbmp tax', 'ghmc tax', 'mcgm tax',
      'property khata'
    ]
  },

  'Children': {
    'Nutrition': [
      'baby food', 'cerelac', 'infant formula', 'lactogen', 'nan pro', 'similac', 'pediasure', 'baby cereal'
    ],
    'Necessities': [
      'diapers', 'pampers', 'huggies', 'baby wipes', 'baby cream', 'baby oil', 'baby powder', 'baby clothes',
      'johnson baby', 'baby lotion', 'baby shampoo'
    ],
    'Toys': [
      'kids toys', 'baby toys', 'educational toys', 'lego', 'barbie', 'hot wheels', 'funskool', 'play school toys'
    ],
    'Medical': [
      'pediatrician', 'child doctor', 'vaccination', 'immunization', 'baby checkup', 'child hospital',
      'child clinic'
    ],
    'Care': [
      'daycare', 'creche', 'babysitter', 'nanny', 'baby care', 'child care', 'play school', 'nursery school'
    ],
    'Tuition Fee': [
      'tuition', 'tuition fee', 'coaching fee', 'private tutor', 'home tutor'
    ],
    'School Fee': [
      'school fee', 'school fees', 'admission fee', 'term fee', 'annual fee', 'bus fee'
    ],
    'College Fee': [
      'college fee', 'university fee', 'semester fee', 'hostel fee', 'exam fee', 'convocation'
    ]
  },

  'Pets': {
    'Food': [
      'pet food', 'dog food', 'cat food', 'pedigree', 'royal canin', 'whiskas', 'drools', 'farmina', 'orijen',
      'pet treats'
    ],
    'Toys': [
      'pet toys', 'dog toys', 'cat toys', 'chew toys', 'squeaky toys', 'rope toy'
    ],
    'Grooming': [
      'pet grooming', 'dog grooming', 'cat grooming', 'pet spa', 'pet salon', 'pet bath', 'pet parlour'
    ],
    'Vet': [
      'vet', 'veterinary', 'pet clinic', 'animal hospital', 'vaccination', 'pet checkup', 'pet medicine',
      'pet surgery'
    ]
  },

  'Business': {
    'Salary payout': [
      'employee salary', 'payroll', 'staff payment', 'staff salary', 'contractor payout'
    ],
    'Inventory': [
      'inventory', 'stock', 'raw material', 'supplies', 'goods', 'purchase stock'
    ],
    'Rent': [
      'office rent', 'shop rent', 'warehouse rent', 'business rent', 'commercial rent'
    ],
    'Logistics': [
      'business logistics', 'freight', 'shipping', 'cargo', 'transport', 'delivery charges', 'courier charges',
      'warehouse logistics'
    ],
    'Software': [
      'business software', 'erp', 'crm', 'zoho', 'salesforce', 'quickbooks', 'tally', 'zoho books', 'zoho crm',
      'freshdesk', 'freshworks', 'hubspot'
    ],
    'Marketing': [
      'marketing', 'advertising', 'ads', 'google ads', 'facebook ads', 'promotion', 'branding',
      'social media marketing', 'linkedin ads', 'instagram ads', 'performance marketing'
    ],
    'Tax': [
      'business tax', 'professional tax', 'corporate tax', 'gst filing', 'tax filing'
    ],
    'Insurance': [
      'business insurance', 'shop insurance', 'commercial insurance', 'fire insurance', 'liability insurance'
    ],
    'Services': [
      'business services', 'professional services', 'outsourcing', 'freelancer', 'contractor', 'consulting fee'
    ]
  },

  'Income': {
    'Salary': [
      'salary', 'salary credit', 'payroll', 'wages', 'stipend', 'monthly salary', 'salary neft', 'salary credit hdfc'
    ],
    'Refund': [
      'refund', 'reversal', 'reversed', 'chargeback', 'refund credit'
    ],
    'Cashback': [
      'cashback', 'reward credit', 'cash back', 'reward points credit', 'scratch card win'
    ],
    'Interest': [
      'interest credit', 'fd interest', 'savings interest', 'dividend credit', 'interest received'
    ]
  },

  'Transfers': {
    'Self transfer': [
      'self transfer', 'to self', 'own account', 'self account', 'account transfer self'
    ],
    'Bank transfer': [
      'neft', 'imps', 'rtgs', 'fund transfer', 'bank transfer', 'account transfer'
    ],
    'Wallet': [
      'phonepe', 'gpay', 'google pay', 'paytm wallet', 'amazon pay wallet', 'mobikwik', 'freecharge wallet',
      'wallet topup', 'wallet load', 'add money'
    ]
  },

  'Misc': {
    'Donation': [
      'donation', 'charity', 'ngo', 'cause', 'give india', 'milaap', 'ketto', 'crowdfunding', 'temple donation', 'hundi', 'ehundi',
      'church donation'
    ],
    'Temple': [
      'temple', 'mandir', 'church', 'mosque', 'gurudwara', 'ttd', 'hundi', 'dakshina', 'offering', 'seva'
    ],
    'Gift': [
      'gift', 'present', 'birthday gift', 'wedding gift', 'anniversary gift', 'gift card', 'voucher',
      'e-gift card'
    ],
    'Others': [
      'misc', 'miscellaneous', 'other expense', 'unknown', 'uncategorized', 'cash', 'atm withdrawal',
      'atm cash', 'upi withdrawal'
    ]
  }
};

export const SUBSCRIPTION_KEYWORDS = [
  'autopay', 'auto pay', 'auto debit', 'emandate', 'e-mandate', 'mandate',
  'recurring payment', 'subscription', 'subs renewal', 'plan renewal',

  'netflix', 'netflix india',
  'prime video', 'amazon prime', 'prime membership', 'prime music',
  'hotstar', 'disney', 'jiohotstar', 'disney hotstar', 'disney plus', 'disney+',

  'spotify', 'spotify india', 'spotify premium',
  'apple music', 'youtube premium', 'youtube music',
  'wynk music', 'jiosaavn', 'jio saavn', 'gaana', 'gaana plus',

  'zee5', 'zee 5', 'sony liv', 'sonyliv', 'voot', 'mx player',
  'alt balaji', 'altbalaji', 'hoichoi', 'aha', 'sun nxt', 'sunnxt',
  'hbo max', 'paramount plus', 'paramount+', 'peacock tv', 'starz',

  'times prime', 'swiggy one', 'zomato pro', 'zomato gold',

  'cult.fit', 'cultfit', 'curefit streaming', 'fittr', 'fitpass',

  'bumble', 'tinder', 'tinder gold', 'tinder plus', 'tinder platinum',
  'hinge', 'okcupid',

  'chatgpt', 'openai', 'gpt plus', 'claude', 'anthropic',
  'midjourney', 'perplexity', 'copilot', 'github copilot', 'replika',
  'otter.ai', 'notion ai',

  'xbox', 'xbox game pass', 'xbox live', 'xbox gold',
  'playstation', 'psn', 'game pass', 'geforce now',
  'playstation plus', 'ps plus', 'ps now',
  'nintendo online', 'nintendo switch online',

  'google play', 'play store', 'google play pass',
  'apple arcade', 'app store subscription',

  'microsoft 365', 'office 365', 'adobe cc', 'creative cloud',
  'canva pro', 'figma', 'figma professional', 'slack', 'zoom pro',
  'dropbox', 'google workspace', 'gsuite', 'g-suite',
  '1password', 'lastpass', 'bitwarden premium',

  'coursera', 'udemy', 'edx', 'udacity', 'pluralsight',
  'linkedin learning', 'skillshare', 'masterclass',
  'byju', 'byjus', 'unacademy', 'vedantu', 'upgrad', 'simplilearn',

  'the ken', 'morning context', 'wall street journal', 'wsj',
  'new york times', 'nytimes', 'ft subscription', 'financial times',

  'chit', 'chitfund', 'chit fund', 'margadarsi', 'shriram chits', 'mysore chits',

  'membership', 'monthly subscription', 'annual subscription',
  'yearly plan', 'recurring', 'auto-renew'
];